import React from "react";
import type { AxisScale } from "../../lib/scale";
import { PLOT_LAYOUT, dataToSvg } from "../../lib/scale";
import { TEXT_SECONDARY } from "../../lib/colors";

type AxisProps = {
  xScale: AxisScale;
  yScale: AxisScale;
  labelX: string;
  labelY: string;
};

const TICK_SIZE = 6;
const TICK_FONT = 24;
const LABEL_FONT = 34;

const Axis: React.FC<AxisProps> = ({ xScale, yScale, labelX, labelY }) => {
  const { left, top, plotWidth, plotHeight } = PLOT_LAYOUT;
  const bottom = top + plotHeight;
  const right = left + plotWidth;

  return (
    <g>
      {/* ── X 軸 ─────────────────────────── */}
      <line
        x1={left}
        y1={bottom}
        x2={right}
        y2={bottom}
        stroke={TEXT_SECONDARY}
        strokeWidth={1.5}
        strokeOpacity={0.5}
      />
      {xScale.ticks.map((tick) => {
        const x = dataToSvg(tick, xScale, left, right);
        return (
          <g key={`xt-${tick}`}>
            <line
              x1={x}
              y1={bottom}
              x2={x}
              y2={bottom + TICK_SIZE}
              stroke={TEXT_SECONDARY}
              strokeOpacity={0.5}
            />
            <text
              x={x}
              y={bottom + TICK_SIZE + TICK_FONT + 4}
              textAnchor="middle"
              fill={TEXT_SECONDARY}
              fontSize={TICK_FONT}
              opacity={0.7}
            >
              {xScale.tickFormat(tick)}
            </text>
          </g>
        );
      })}
      {/* X 軸ラベル */}
      <text
        x={left + plotWidth / 2}
        y={bottom + 75}
        textAnchor="middle"
        fill={TEXT_SECONDARY}
        fontSize={LABEL_FONT}
      >
        {labelX} (円)
      </text>

      {/* ── Y 軸 ─────────────────────────── */}
      <line
        x1={left}
        y1={top}
        x2={left}
        y2={bottom}
        stroke={TEXT_SECONDARY}
        strokeWidth={1.5}
        strokeOpacity={0.5}
      />
      {yScale.ticks.map((tick) => {
        const y = dataToSvg(tick, yScale, bottom, top);
        return (
          <g key={`yt-${tick}`}>
            <line
              x1={left - TICK_SIZE}
              y1={y}
              x2={left}
              y2={y}
              stroke={TEXT_SECONDARY}
              strokeOpacity={0.5}
            />
            <text
              x={left - TICK_SIZE - 8}
              y={y + TICK_FONT / 3}
              textAnchor="end"
              fill={TEXT_SECONDARY}
              fontSize={TICK_FONT}
              opacity={0.7}
            >
              {yScale.tickFormat(tick)}
            </text>
          </g>
        );
      })}
      {/* Y 軸ラベル */}
      <text
        x={0}
        y={0}
        textAnchor="middle"
        fill={TEXT_SECONDARY}
        fontSize={LABEL_FONT}
        transform={`translate(${left - 80}, ${top + plotHeight / 2}) rotate(-90)`}
      >
        {labelY} (円)
      </text>
    </g>
  );
};

export default Axis;
